// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__3PUUW","content":"TermsOfServicePage_content__2vqhg"};